/* tslint:disable */
/* eslint-disable */
/**
 * CAST.AI API documentation
 * ### Feature maturity indicators (may appear on resources, operations and request/response fields)  - **(BETA)** - new or experimental features, subject to change  - **(Deprecated)** - outdated or replaced features (a reason and removal date will be provided in the description) 
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { BillingV1GetEnterprisePlatformUsageDetailResponse } from '../models';
// @ts-ignore
import type { BillingV1GetEnterprisePlatformUsageReportResponse } from '../models';
// @ts-ignore
import type { BillingV1GetPlatformUsageDetailResponse } from '../models';
// @ts-ignore
import type { BillingV1GetPlatformUsageReportResponse } from '../models';
// @ts-ignore
import type { BillingV1GetSubscriptionDetailsResponse } from '../models';
// @ts-ignore
import type { HostedPage } from '../models';
// @ts-ignore
import type { PortalSession } from '../models';
// @ts-ignore
import type { Subscription } from '../models';
/**
 * BillingAPIApi - axios parameter creator
 * @export
 */
export const BillingAPIApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary GetEnterprisePlatformUsageDetail returns detailed per-organization usage breakdown for a specific feature across all child organizations of an enterprise organization.
         * @param {string} periodFrom Start date (inclusive), format: YYYY-MM-DD.
         * @param {string} periodTo End date (inclusive), format: YYYY-MM-DD.
         * @param {string} feature Feature name to get detail for (e.g., \&quot;phase2\&quot;, \&quot;woop\&quot;).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        billingAPIGetEnterprisePlatformUsageDetail: async (periodFrom: string, periodTo: string, feature: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'periodFrom' is not null or undefined
            assertParamExists('billingAPIGetEnterprisePlatformUsageDetail', 'periodFrom', periodFrom)
            // verify required parameter 'periodTo' is not null or undefined
            assertParamExists('billingAPIGetEnterprisePlatformUsageDetail', 'periodTo', periodTo)
            // verify required parameter 'feature' is not null or undefined
            assertParamExists('billingAPIGetEnterprisePlatformUsageDetail', 'feature', feature)
            const localVarPath = `/v1/billing/enterprise/platform-usage-detail`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (periodFrom !== undefined) {
                localVarQueryParameter['period.from'] = periodFrom;
            }

            if (periodTo !== undefined) {
                localVarQueryParameter['period.to'] = periodTo;
            }

            if (feature !== undefined) {
                localVarQueryParameter['feature'] = feature;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary GetEnterprisePlatformUsageReport returns usage report broken down by feature across all child organizations for an enterprise organization (current month).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        billingAPIGetEnterprisePlatformUsageReport: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/billing/enterprise/platform-usage-report`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary GetPlatformUsageDetail returns detailed per-cluster usage breakdown for a specific feature.
         * @param {string} periodFrom Start date (inclusive), format: YYYY-MM-DD.
         * @param {string} periodTo End date (inclusive), format: YYYY-MM-DD.
         * @param {string} feature Feature name to get detail for (e.g., \&quot;phase2\&quot;, \&quot;woop\&quot;).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        billingAPIGetPlatformUsageDetail: async (periodFrom: string, periodTo: string, feature: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'periodFrom' is not null or undefined
            assertParamExists('billingAPIGetPlatformUsageDetail', 'periodFrom', periodFrom)
            // verify required parameter 'periodTo' is not null or undefined
            assertParamExists('billingAPIGetPlatformUsageDetail', 'periodTo', periodTo)
            // verify required parameter 'feature' is not null or undefined
            assertParamExists('billingAPIGetPlatformUsageDetail', 'feature', feature)
            const localVarPath = `/v1/billing/platform-usage-detail`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (periodFrom !== undefined) {
                localVarQueryParameter['period.from'] = periodFrom;
            }

            if (periodTo !== undefined) {
                localVarQueryParameter['period.to'] = periodTo;
            }

            if (feature !== undefined) {
                localVarQueryParameter['feature'] = feature;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary GetPlatformUsageReport returns usage report broken down by feature for an organization (current month).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        billingAPIGetPlatformUsageReport: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/billing/platform-usage-report`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary GetSubscriptionDetails returns subscription details for the given organization.
         * @param {string} organizationId Organization ID.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        billingAPIGetSubscriptionDetails: async (organizationId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('billingAPIGetSubscriptionDetails', 'organizationId', organizationId)
            const localVarPath = `/v1/billing/subscription-details/{organizationId}`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Builds URL to use in end-customer\'s browser session as an iframe. URL will direct to ChargeBee portal session. Can be tailored with specific portal URL. When application/json media type is requested - returns portal session object for generating a chargeBee hosted portal session popup.
         * @summary Single sign-on of ChargeBee portal.
         * @param {string} [forwardUrl] Desired destination URL within ChargeBee. See https://apidocs.chargebee.com/docs/api/portal_sessions#create_a_portal_session_forward_url for more details. 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        billingSso: async (forwardUrl?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/billing/sso`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (forwardUrl !== undefined) {
                localVarQueryParameter['forwardUrl'] = forwardUrl;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieves user\'s subscription details from ChargeBee.
         * @summary Retrieves current user\'s subscription details.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        subscription: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/billing/subscription`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Builds URL to use in end-customer\'s browser session as an iframe. URL will direct to ChargeBee default subscription checkout form. When application/json media type is requested - returns hosted page object for generating checkout popup in end-customer\'s browser session.
         * @summary Checkout current user\'s subscription.
         * @param {string} [plan] Checkout specific subscription plan.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        subscriptionCheckout: async (plan?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/billing/subscription/checkout`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (plan !== undefined) {
                localVarQueryParameter['plan'] = plan;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * BillingAPIApi - functional programming interface
 * @export
 */
export const BillingAPIApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = BillingAPIApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary GetEnterprisePlatformUsageDetail returns detailed per-organization usage breakdown for a specific feature across all child organizations of an enterprise organization.
         * @param {string} periodFrom Start date (inclusive), format: YYYY-MM-DD.
         * @param {string} periodTo End date (inclusive), format: YYYY-MM-DD.
         * @param {string} feature Feature name to get detail for (e.g., \&quot;phase2\&quot;, \&quot;woop\&quot;).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async billingAPIGetEnterprisePlatformUsageDetail(periodFrom: string, periodTo: string, feature: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BillingV1GetEnterprisePlatformUsageDetailResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.billingAPIGetEnterprisePlatformUsageDetail(periodFrom, periodTo, feature, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BillingAPIApi.billingAPIGetEnterprisePlatformUsageDetail']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary GetEnterprisePlatformUsageReport returns usage report broken down by feature across all child organizations for an enterprise organization (current month).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async billingAPIGetEnterprisePlatformUsageReport(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BillingV1GetEnterprisePlatformUsageReportResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.billingAPIGetEnterprisePlatformUsageReport(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BillingAPIApi.billingAPIGetEnterprisePlatformUsageReport']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary GetPlatformUsageDetail returns detailed per-cluster usage breakdown for a specific feature.
         * @param {string} periodFrom Start date (inclusive), format: YYYY-MM-DD.
         * @param {string} periodTo End date (inclusive), format: YYYY-MM-DD.
         * @param {string} feature Feature name to get detail for (e.g., \&quot;phase2\&quot;, \&quot;woop\&quot;).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async billingAPIGetPlatformUsageDetail(periodFrom: string, periodTo: string, feature: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BillingV1GetPlatformUsageDetailResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.billingAPIGetPlatformUsageDetail(periodFrom, periodTo, feature, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BillingAPIApi.billingAPIGetPlatformUsageDetail']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary GetPlatformUsageReport returns usage report broken down by feature for an organization (current month).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async billingAPIGetPlatformUsageReport(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BillingV1GetPlatformUsageReportResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.billingAPIGetPlatformUsageReport(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BillingAPIApi.billingAPIGetPlatformUsageReport']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary GetSubscriptionDetails returns subscription details for the given organization.
         * @param {string} organizationId Organization ID.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async billingAPIGetSubscriptionDetails(organizationId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BillingV1GetSubscriptionDetailsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.billingAPIGetSubscriptionDetails(organizationId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BillingAPIApi.billingAPIGetSubscriptionDetails']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Builds URL to use in end-customer\'s browser session as an iframe. URL will direct to ChargeBee portal session. Can be tailored with specific portal URL. When application/json media type is requested - returns portal session object for generating a chargeBee hosted portal session popup.
         * @summary Single sign-on of ChargeBee portal.
         * @param {string} [forwardUrl] Desired destination URL within ChargeBee. See https://apidocs.chargebee.com/docs/api/portal_sessions#create_a_portal_session_forward_url for more details. 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async billingSso(forwardUrl?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PortalSession>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.billingSso(forwardUrl, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BillingAPIApi.billingSso']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieves user\'s subscription details from ChargeBee.
         * @summary Retrieves current user\'s subscription details.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async subscription(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Subscription>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.subscription(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BillingAPIApi.subscription']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Builds URL to use in end-customer\'s browser session as an iframe. URL will direct to ChargeBee default subscription checkout form. When application/json media type is requested - returns hosted page object for generating checkout popup in end-customer\'s browser session.
         * @summary Checkout current user\'s subscription.
         * @param {string} [plan] Checkout specific subscription plan.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async subscriptionCheckout(plan?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<HostedPage>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.subscriptionCheckout(plan, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BillingAPIApi.subscriptionCheckout']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * BillingAPIApi - factory interface
 * @export
 */
export const BillingAPIApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = BillingAPIApiFp(configuration)
    return {
        /**
         * 
         * @summary GetEnterprisePlatformUsageDetail returns detailed per-organization usage breakdown for a specific feature across all child organizations of an enterprise organization.
         * @param {BillingAPIApiBillingAPIGetEnterprisePlatformUsageDetailRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        billingAPIGetEnterprisePlatformUsageDetail(requestParameters: BillingAPIApiBillingAPIGetEnterprisePlatformUsageDetailRequest, options?: RawAxiosRequestConfig): AxiosPromise<BillingV1GetEnterprisePlatformUsageDetailResponse> {
            return localVarFp.billingAPIGetEnterprisePlatformUsageDetail(requestParameters.periodFrom, requestParameters.periodTo, requestParameters.feature, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary GetEnterprisePlatformUsageReport returns usage report broken down by feature across all child organizations for an enterprise organization (current month).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        billingAPIGetEnterprisePlatformUsageReport(options?: RawAxiosRequestConfig): AxiosPromise<BillingV1GetEnterprisePlatformUsageReportResponse> {
            return localVarFp.billingAPIGetEnterprisePlatformUsageReport(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary GetPlatformUsageDetail returns detailed per-cluster usage breakdown for a specific feature.
         * @param {BillingAPIApiBillingAPIGetPlatformUsageDetailRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        billingAPIGetPlatformUsageDetail(requestParameters: BillingAPIApiBillingAPIGetPlatformUsageDetailRequest, options?: RawAxiosRequestConfig): AxiosPromise<BillingV1GetPlatformUsageDetailResponse> {
            return localVarFp.billingAPIGetPlatformUsageDetail(requestParameters.periodFrom, requestParameters.periodTo, requestParameters.feature, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary GetPlatformUsageReport returns usage report broken down by feature for an organization (current month).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        billingAPIGetPlatformUsageReport(options?: RawAxiosRequestConfig): AxiosPromise<BillingV1GetPlatformUsageReportResponse> {
            return localVarFp.billingAPIGetPlatformUsageReport(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary GetSubscriptionDetails returns subscription details for the given organization.
         * @param {BillingAPIApiBillingAPIGetSubscriptionDetailsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        billingAPIGetSubscriptionDetails(requestParameters: BillingAPIApiBillingAPIGetSubscriptionDetailsRequest, options?: RawAxiosRequestConfig): AxiosPromise<BillingV1GetSubscriptionDetailsResponse> {
            return localVarFp.billingAPIGetSubscriptionDetails(requestParameters.organizationId, options).then((request) => request(axios, basePath));
        },
        /**
         * Builds URL to use in end-customer\'s browser session as an iframe. URL will direct to ChargeBee portal session. Can be tailored with specific portal URL. When application/json media type is requested - returns portal session object for generating a chargeBee hosted portal session popup.
         * @summary Single sign-on of ChargeBee portal.
         * @param {BillingAPIApiBillingSsoRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        billingSso(requestParameters: BillingAPIApiBillingSsoRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<PortalSession> {
            return localVarFp.billingSso(requestParameters.forwardUrl, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieves user\'s subscription details from ChargeBee.
         * @summary Retrieves current user\'s subscription details.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        subscription(options?: RawAxiosRequestConfig): AxiosPromise<Subscription> {
            return localVarFp.subscription(options).then((request) => request(axios, basePath));
        },
        /**
         * Builds URL to use in end-customer\'s browser session as an iframe. URL will direct to ChargeBee default subscription checkout form. When application/json media type is requested - returns hosted page object for generating checkout popup in end-customer\'s browser session.
         * @summary Checkout current user\'s subscription.
         * @param {BillingAPIApiSubscriptionCheckoutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        subscriptionCheckout(requestParameters: BillingAPIApiSubscriptionCheckoutRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<HostedPage> {
            return localVarFp.subscriptionCheckout(requestParameters.plan, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for billingAPIGetEnterprisePlatformUsageDetail operation in BillingAPIApi.
 * @export
 * @interface BillingAPIApiBillingAPIGetEnterprisePlatformUsageDetailRequest
 */
export interface BillingAPIApiBillingAPIGetEnterprisePlatformUsageDetailRequest {
    /**
     * Start date (inclusive), format: YYYY-MM-DD.
     * @type {string}
     * @memberof BillingAPIApiBillingAPIGetEnterprisePlatformUsageDetail
     */
    readonly periodFrom: string

    /**
     * End date (inclusive), format: YYYY-MM-DD.
     * @type {string}
     * @memberof BillingAPIApiBillingAPIGetEnterprisePlatformUsageDetail
     */
    readonly periodTo: string

    /**
     * Feature name to get detail for (e.g., \&quot;phase2\&quot;, \&quot;woop\&quot;).
     * @type {string}
     * @memberof BillingAPIApiBillingAPIGetEnterprisePlatformUsageDetail
     */
    readonly feature: string
}

/**
 * Request parameters for billingAPIGetPlatformUsageDetail operation in BillingAPIApi.
 * @export
 * @interface BillingAPIApiBillingAPIGetPlatformUsageDetailRequest
 */
export interface BillingAPIApiBillingAPIGetPlatformUsageDetailRequest {
    /**
     * Start date (inclusive), format: YYYY-MM-DD.
     * @type {string}
     * @memberof BillingAPIApiBillingAPIGetPlatformUsageDetail
     */
    readonly periodFrom: string

    /**
     * End date (inclusive), format: YYYY-MM-DD.
     * @type {string}
     * @memberof BillingAPIApiBillingAPIGetPlatformUsageDetail
     */
    readonly periodTo: string

    /**
     * Feature name to get detail for (e.g., \&quot;phase2\&quot;, \&quot;woop\&quot;).
     * @type {string}
     * @memberof BillingAPIApiBillingAPIGetPlatformUsageDetail
     */
    readonly feature: string
}

/**
 * Request parameters for billingAPIGetSubscriptionDetails operation in BillingAPIApi.
 * @export
 * @interface BillingAPIApiBillingAPIGetSubscriptionDetailsRequest
 */
export interface BillingAPIApiBillingAPIGetSubscriptionDetailsRequest {
    /**
     * Organization ID.
     * @type {string}
     * @memberof BillingAPIApiBillingAPIGetSubscriptionDetails
     */
    readonly organizationId: string
}

/**
 * Request parameters for billingSso operation in BillingAPIApi.
 * @export
 * @interface BillingAPIApiBillingSsoRequest
 */
export interface BillingAPIApiBillingSsoRequest {
    /**
     * Desired destination URL within ChargeBee. See https://apidocs.chargebee.com/docs/api/portal_sessions#create_a_portal_session_forward_url for more details. 
     * @type {string}
     * @memberof BillingAPIApiBillingSso
     */
    readonly forwardUrl?: string
}

/**
 * Request parameters for subscriptionCheckout operation in BillingAPIApi.
 * @export
 * @interface BillingAPIApiSubscriptionCheckoutRequest
 */
export interface BillingAPIApiSubscriptionCheckoutRequest {
    /**
     * Checkout specific subscription plan.
     * @type {string}
     * @memberof BillingAPIApiSubscriptionCheckout
     */
    readonly plan?: string
}

/**
 * BillingAPIApi - object-oriented interface
 * @export
 * @class BillingAPIApi
 * @extends {BaseAPI}
 */
export class BillingAPIApi extends BaseAPI {
    /**
     * 
     * @summary GetEnterprisePlatformUsageDetail returns detailed per-organization usage breakdown for a specific feature across all child organizations of an enterprise organization.
     * @param {BillingAPIApiBillingAPIGetEnterprisePlatformUsageDetailRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BillingAPIApi
     */
    public billingAPIGetEnterprisePlatformUsageDetail(requestParameters: BillingAPIApiBillingAPIGetEnterprisePlatformUsageDetailRequest, options?: RawAxiosRequestConfig) {
        return BillingAPIApiFp(this.configuration).billingAPIGetEnterprisePlatformUsageDetail(requestParameters.periodFrom, requestParameters.periodTo, requestParameters.feature, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary GetEnterprisePlatformUsageReport returns usage report broken down by feature across all child organizations for an enterprise organization (current month).
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BillingAPIApi
     */
    public billingAPIGetEnterprisePlatformUsageReport(options?: RawAxiosRequestConfig) {
        return BillingAPIApiFp(this.configuration).billingAPIGetEnterprisePlatformUsageReport(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary GetPlatformUsageDetail returns detailed per-cluster usage breakdown for a specific feature.
     * @param {BillingAPIApiBillingAPIGetPlatformUsageDetailRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BillingAPIApi
     */
    public billingAPIGetPlatformUsageDetail(requestParameters: BillingAPIApiBillingAPIGetPlatformUsageDetailRequest, options?: RawAxiosRequestConfig) {
        return BillingAPIApiFp(this.configuration).billingAPIGetPlatformUsageDetail(requestParameters.periodFrom, requestParameters.periodTo, requestParameters.feature, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary GetPlatformUsageReport returns usage report broken down by feature for an organization (current month).
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BillingAPIApi
     */
    public billingAPIGetPlatformUsageReport(options?: RawAxiosRequestConfig) {
        return BillingAPIApiFp(this.configuration).billingAPIGetPlatformUsageReport(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary GetSubscriptionDetails returns subscription details for the given organization.
     * @param {BillingAPIApiBillingAPIGetSubscriptionDetailsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BillingAPIApi
     */
    public billingAPIGetSubscriptionDetails(requestParameters: BillingAPIApiBillingAPIGetSubscriptionDetailsRequest, options?: RawAxiosRequestConfig) {
        return BillingAPIApiFp(this.configuration).billingAPIGetSubscriptionDetails(requestParameters.organizationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Builds URL to use in end-customer\'s browser session as an iframe. URL will direct to ChargeBee portal session. Can be tailored with specific portal URL. When application/json media type is requested - returns portal session object for generating a chargeBee hosted portal session popup.
     * @summary Single sign-on of ChargeBee portal.
     * @param {BillingAPIApiBillingSsoRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BillingAPIApi
     */
    public billingSso(requestParameters: BillingAPIApiBillingSsoRequest = {}, options?: RawAxiosRequestConfig) {
        return BillingAPIApiFp(this.configuration).billingSso(requestParameters.forwardUrl, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieves user\'s subscription details from ChargeBee.
     * @summary Retrieves current user\'s subscription details.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BillingAPIApi
     */
    public subscription(options?: RawAxiosRequestConfig) {
        return BillingAPIApiFp(this.configuration).subscription(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Builds URL to use in end-customer\'s browser session as an iframe. URL will direct to ChargeBee default subscription checkout form. When application/json media type is requested - returns hosted page object for generating checkout popup in end-customer\'s browser session.
     * @summary Checkout current user\'s subscription.
     * @param {BillingAPIApiSubscriptionCheckoutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BillingAPIApi
     */
    public subscriptionCheckout(requestParameters: BillingAPIApiSubscriptionCheckoutRequest = {}, options?: RawAxiosRequestConfig) {
        return BillingAPIApiFp(this.configuration).subscriptionCheckout(requestParameters.plan, options).then((request) => request(this.axios, this.basePath));
    }
}

